import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPeriodEventDataBuilder,
  fetchBestWorstStudentsBuilder,
} from "./builder";

const initialState = {
  periodEventData: {
    data: [],
  },
  bestStudent: { data: [] },
  worstStudent: { data: [] },
};

export const periodEventDataSlice = createSlice({
  name: "periodEventData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchPeriodEventDataBuilder(builder);
    fetchBestWorstStudentsBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectPeriodEventData = (state) =>
  state.periodEventData.periodEventData;

export const selectBestStudents = (state) => state.periodEventData.bestStudent;

export const selectWorstStudents = (state) =>
  state.periodEventData.worstStudent;

export default periodEventDataSlice.reducer;
